var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.0773C10.7812 12.0773 9.375 11.5137 8.28125 10.3865C7.1875 9.25926 6.64062 7.80999 6.64062 6.03865C6.64062 4.26731 7.1875 2.81804 8.28125 1.69082C9.375 0.563607 10.7812 0 12.5 0C14.2188 0 15.625 0.563607 16.7188 1.69082C17.8125 2.81804 18.3594 4.26731 18.3594 6.03865C18.3594 7.80999 17.8125 9.25926 16.7188 10.3865C15.625 11.5137 14.2188 12.0773 12.5 12.0773ZM0 25V21.2158C0 20.1959 0.247396 19.3237 0.742187 18.599C1.23698 17.8744 1.875 17.3242 2.65625 16.9485C4.40104 16.1433 6.07422 15.5395 7.67578 15.1369C9.27734 14.7343 10.8854 14.533 12.5 14.533C14.1146 14.533 15.7161 14.741 17.3047 15.157C18.8932 15.573 20.5599 16.1702 22.3047 16.9485C23.112 17.3242 23.763 17.8744 24.2578 18.599C24.7526 19.3237 25 20.1959 25 21.2158V25H0Z",
    fill: "#447FA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2ef0b80ce55b497c13176f0fd4a4770d.svg";
export { ForwardRef as ReactComponent };